import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IOrderListModel } from '@apps-common/types/portal/order'

export const QUERY_GET_ORDERS_RECENT = (take = 4) => ['getOrdersRecent', take]

export const getOrders = async (
  orderNo: string,
  startDate: string | null,
  endDate: string | null,
  status: string,
  skip: number,
  take: number
): Promise<IOrderListModel[]> =>
  axios
    .get(
      `/Order/Orders?orderNo=${orderNo}${startDate ? `&startDate=${startDate}` : ''}${endDate ? `&endDate=${endDate}` : ''}&status=${status}&skip=${skip}&take=${take}`
    )
    .then((res) => res.data?.data)

type QueryFnType = typeof getOrders

type Props = {
  config?: QueryConfig<QueryFnType>
  take: number
}

export const useGetRecentOrders = ({ config, take }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_GET_ORDERS_RECENT(take),
    queryFn: () => getOrders('', null, null, '', 0, take)
  })
